import { Box } from '@mui/material';

const PageWrapper = ({ children }) => {
    return <Box sx={{ display: 'flex', justifyContent: 'center', flexGrow: 1 }}>{children}</Box>;
};

export default PageWrapper;
